(function () {
  "use strict";

  CompleteTraineesCtrl.$inject = ['$scope', '$timeout'];
  angular
    .module('trainerWebApp.modals')
    .controller('CompleteTraineesCtrl', CompleteTraineesCtrl);

  function CompleteTraineesCtrl($scope, $timeout) {
    $scope.modal = {
      content: 0,
      data: {},
      status: ''
    };

    $scope.completeCourse = function () {
      $scope.modal.status = 'saving';
      $scope.$emit('courseBulkCompleteConfirmed', $scope.modal.data, function () {
        $scope.dismiss();
        $timeout(function () {
          $scope.modal.status = ''
        }, 500);
      });
    };

    $scope.$on('courseBulkCompleteRequested', function (event, numberOfTrainees) {
      $scope.modal.status = '';
      $scope.modal.content = numberOfTrainees;
    });
  }

})();
